export function calculateOpacity(index: number, length: number) {
  return index / (length * 2) + 0.3;
}
